<content-loader height="475" width="400" viewBox="0 0 400 475">
  <svg:rect x="0" y="0" rx="3" ry="3" width="400" height="20" />
  <svg:rect x="0" y="30" rx="3" ry="3" width="400" height="300" />
</content-loader>
